import React, { useState } from 'react'

import searchIcon from '../../assets/images/search.png'

function SelectStation({ t, handleClose, stations, handleStationClick }) {
  const [inputFocus, setInputFocus] = useState(false)
  const [filterStation, setFilterStation] = useState('')

  const filteredStations = filterStation ? stations.filter(s => s.label.toUpperCase().includes(filterStation.toUpperCase())) : stations

  return (
    <div id="overlay-local" className="text-center overlay">
      <div className="pt-5 container">
        <div className="close" id="close">
          <img src={require(`../../assets/images/ico-close.png`)} alt="X" onClick={handleClose} />
        </div>
        <div>
          <p className="color-white">
            {t('selectPickupStation')}
          </p>
          <form autoComplete="off">
            <div className="autocomplete" style={{ position: 'relative' }}>
              <input onBlur={() => setInputFocus(false)} onFocus={() => setInputFocus(true)} onChange={e => setFilterStation(e.target.value)} id="devolucao" type="text" name="local_devolucao" className="w-100" />
              <img style={inputFocus || filterStation ? { left: '5px' } : { left: '50%', transform: 'translateX(-50%)' }} src={searchIcon} className='station-input__icon' />
            </div>
            <div id="autocomplete-container" className="pickup-list">
              <div id="devolucao-autocomplete-list" className="autocomplete-items">
                {filteredStations.map(s =>
                  <div key={s.stationId} className="board-background" onClick={() => handleStationClick(s)}>{s.label}<input id="local-escolhido" type="hidden" value={s.label} /></div>
                )}
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default SelectStation